import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function DeadlineBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Friday, January 30th, 2026 at 11:59 PM Eastern Time
    const deadline = new Date('2026-01-30T23:59:59-05:00').getTime();
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = deadline - now;
      if (distance < 0) {
        clearInterval(timer);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 bg-red-950 border-b-2 border-red-600 py-2 px-3" data-id="element-604">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 md:gap-4" data-id="element-605">
        {/* Left side: Timer message and countdown */}
        <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0" data-id="element-606">
          <Clock className="w-4 h-4 md:w-5 md:h-5 text-red-500 animate-pulse flex-shrink-0" data-id="element-607" />
          <div className="flex flex-col md:flex-row md:items-center md:gap-4 min-w-0" data-id="element-608">
            <p className="text-red-100 font-bold text-xs md:text-base leading-tight" data-id="element-609">
              Offer Expires In
            </p>
            <div className="flex items-center gap-1.5 text-red-100 text-xs md:text-sm" data-id="element-610">
              <span className="font-mono font-bold" data-id="element-611">
                {String(timeLeft.days).padStart(2, '0')}d
              </span>
              <span data-id="element-612">:</span>
              <span className="font-mono font-bold" data-id="element-613">
                {String(timeLeft.hours).padStart(2, '0')}h
              </span>
              <span data-id="element-614">:</span>
              <span className="font-mono font-bold" data-id="element-615">
                {String(timeLeft.minutes).padStart(2, '0')}m
              </span>
              <span data-id="element-616">:</span>
              <span className="font-mono font-bold" data-id="element-617">
                {String(timeLeft.seconds).padStart(2, '0')}s
              </span>
            </div>
          </div>
        </div>

        {/* Right side: CTA Button */}
        <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" className="flex-shrink-0 px-3 md:px-6 py-1.5 md:py-2 bg-amber-500 hover:bg-amber-400 text-black font-bold text-xs md:text-base rounded-lg transition-all duration-300 shadow-lg hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap" data-id="element-618">
          Join Now
        </a>
      </div>
    </div>;
}